// extracted by mini-css-extract-plugin
module.exports = {"form":"contact-module--form--2wWrd","item":"contact-module--item--3Md28","input":"contact-module--input--23JuC","submitButton":"contact-module--submit-button--1gUxl"};